import { Injectable } from '@angular/core';
import { Cutting } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter, ConverterService } from '../../../../core/util';
import { UNIT_NORMALIZER } from './converters';

@Injectable({ providedIn: 'root' })
export class CuttingNormalizer implements Converter<Occ.Cutting, Cutting> {
  constructor(private converter: ConverterService) {}

  convert(source: Occ.Cutting, target?: Cutting): Cutting {
    if (source) {
      target = this.convertCutting(source);
    }

    return target;
  }

  private convertCutting(source: Occ.Cutting): Cutting {
    if (source) {
      const { resultingUnit, resultingQuantity, ...target } = source;
      return {
        ...target,
        grainDirection: target.grainDirection, // 0 != mother. 1 = mother 2. = any.
        resultingQuantity: {
          value: source.resultingQuantity,
          unit: this.converter.convert(resultingUnit, UNIT_NORMALIZER),
        },
      };
    } else {
      return undefined;
    }
  }
}
